import locationsBackground from 'website/assets/locations-background.png'

const assets: Record<string, string> = {
  locationsBackground
}

export default assets
